import { ReactNode } from "react";
import { cx } from "utils";


export const SectionRightHandSide = ({children, className}: {children: ReactNode | ReactNode[], className?: string}) => {
  return (<div className={cx("grow basis-80 text-base text-gray dark:text-neutral-600 relative", className)}>
    {children}
  </div>);
}
